import { useMemo, useState } from 'react';

export function useClientPagination<T>(items: T[], pageSize: number) {
  const [page, setPage] = useState(0);
  const totalPages = Math.max(1, Math.ceil(items.length / pageSize));
  const currentPage = Math.min(page, totalPages - 1);
  const pagedItems = useMemo(() => {
    const start = currentPage * pageSize;
    return items.slice(start, start + pageSize);
  }, [currentPage, items, pageSize]);

  return {
    page: currentPage,
    totalPages,
    pagedItems,
    resetPage: () => setPage(0),
    previousPage: () => setPage(value => Math.max(0, value - 1)),
    nextPage: () => setPage(value => Math.min(totalPages - 1, value + 1)),
  };
}
